import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../../components/footer/Footer";
import GetStartedHero from "../../components/getStarted/GetStartedHero";
// import NavBar from "../../components/NavBar/NavBar";
import TopNav from "../../components/TopNav/TopNav";

const GetStartedPage = () => {
  return (
    <div>
      <Helmet>
        <title>TradeBuza - Get Started</title>
        <meta name='description' content='Schedule a demo to get started.' />
        <link rel='canonical' href='https://www.tradebuza.com/get-started' />
      </Helmet>
      {/* <NavBar /> */}
      <TopNav />
      <GetStartedHero />
      <Footer />
    </div>
  );
};

export default GetStartedPage;
